export function downloadFile(response: any, filename: string | null = null): void {
  console.log(response);
  let dataType = response.type;
  let binaryData = [];
  binaryData.push(response);
  const div = document.createElement('div');
  let downloadLink = document.createElement('a');
  downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, { type: dataType }));
  if (filename) downloadLink.setAttribute('download', filename);
  downloadLink.setAttribute('target', '_blank');
  div.appendChild(downloadLink);
  document.body.appendChild(div);
  downloadLink.click();
  downloadLink.parentNode.removeChild(downloadLink);
}
